import type { ComponentType, ReactNode } from 'react';
import type { TimelineRecordAuthorProps } from '../types/configTypes';
import type { TimelineItem } from '../types/types';
import TimelineRecordLayout from './TimelineRecordLayout';

interface TimelineRecordFormItemProps {
  item: TimelineItem;
  RecordAuthor: ComponentType<TimelineRecordAuthorProps>;
  children: ReactNode;
  isAdd?: boolean;
  isHighlighted?: boolean;
  tag: ReactNode;
  tagColor?: TimelineItem['tagColor'];
}

const TimelineRecordFormItem = ({
  item,
  RecordAuthor,
  children,
  isAdd = false,
  isHighlighted,
  tag,
  tagColor,
}: TimelineRecordFormItemProps) => (
  <TimelineRecordLayout
    item={item}
    RecordAuthor={RecordAuthor}
    isHighlighted={isHighlighted}
    showRecordMeta={!isAdd}
    tag={tag}
    tagColor={tagColor}
  >
    {children}
  </TimelineRecordLayout>
);

export default TimelineRecordFormItem;
